import { ERR_INVALID_COOKIE } from './ERR_INVALID_COOKIE.js';
import { getCookieValues } from './getCookieValues.js';
import { getDomainAttribute } from './getDomainAttribute.js';
import { isValidCookie } from './isValidCookie.js';
import { memoizedCookies } from './memoizedCookies.js';

const setSessionCookie = ({
  name,
  value
}) => {
  if (!isValidCookie(name, value)) {
    throw new Error(`${ERR_INVALID_COOKIE} ${name}=${value}`);
  }
  document.cookie = `${name}=${value}; path=/;${getDomainAttribute()}`;
  if (memoizedCookies.has(name)) {
    const [value2] = getCookieValues(name);
    if (value2) {
      memoizedCookies.set(name, value2);
    }
  }
};

export { setSessionCookie };
